import { render, staticRenderFns } from "./accountOpeningPermit.vue?vue&type=template&id=71a94482&scoped=true&"
import script from "./accountOpeningPermit.vue?vue&type=script&lang=js&"
export * from "./accountOpeningPermit.vue?vue&type=script&lang=js&"
import style0 from "./accountOpeningPermit.vue?vue&type=style&index=0&id=71a94482&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a94482",
  null
  
)

export default component.exports